import "./css/modern-normalize.css";
import "./css/main-style.css";
import { displayHeader, displayInfoBar, displaySetup } from "./js/ui";

displayHeader();
displaySetup();
displayInfoBar();
